function Link(props = { text, to, icon }) {
  return (
    <a {...props} href={props.to} target='_blank'>
      {props.icon && <i className={props.icon}></i>}
      <span>{props.text}</span>
    </a>
  );
}

export default Link;
